import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import React, { useState } from "react";
import {
  Button,
  Header,
  Image,
  Modal,
  Table,
  Card,
  Grid,
} from "semantic-ui-react";
import CompanyPage from "../company/CompanyPage";
import "../css/home.css";
import Utils from "../util/Utils";
import "./styles.css";
import Typography from "@mui/material/Typography";

export default function StockScreener(props) {
  const [stateValues, setStateValues] = useState({
    open: false,
    modalSymbol: "",
  });

  const showModal = (event) => {
    if (event.colDef.field === "symbol") {
      setStateValues({ ...stateValues, modalSymbol: event.value, open: true });
    }
  };

  const setOpen = (flag) => {
    setStateValues({ ...stateValues, open: flag });
  };

  const defaultColDef = {
    resizable: true,
    floatingFilter: true,
  };

  const overlayLoadingTemplate =
    '<span class="ag-overlay-loading-center">Please wait while data is loading</span>';

  const ColourCellRenderer = (props) => (
    <span
      style={{
        color: "blue",
        cursor: "pointer",
        textDecoration: "underline",
      }}
    >
      {props.value}
    </span>
  );

  const columnDefs = [
    {
      headerName: "Symbol",
      field: "symbol",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 100,
      pinned: "left",
      cellRenderer: ColourCellRenderer,
    },
    {
      headerName: "Current Price",
      field: "price",
      filter: "agNumberColumnFilter",
      valueFormatter: Utils.ag_currencyFormatter,
      sortable: true,
      width: 120,
    },
    {
      headerName: "Perf 1 day",
      headerTooltip: "Perf to Day",
      field: "perfDay",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 100,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "Perf to Week",
      headerTooltip: "Perf to Week",
      field: "perfWeek",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 120,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "Perf to Month",
      headerTooltip: "Perf to Month",
      field: "perfMonth",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 120,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "Perf to YTD",
      headerTooltip: "Perf to YTD",
      field: "perfYTD",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 120,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "Perf to Year",
      headerTooltip: "Perf to Year",
      field: "perfYear",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 120,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "2Y (Annualized)",
      headerTooltip: "Compound annual growth rate over 2 years",
      field: "perf2Year",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 125,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "3Y (Annualized)",
      headerTooltip: "Compound annual growth rate over 3 years",
      field: "perf3Year",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 125,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "5Y (Annualized)",
      headerTooltip: "Compound annual growth rate over 5 years",
      field: "perf5Year",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 130,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "10Y (Annualized)",
      headerTooltip: "Compound annual growth rate over 10 years",
      field: "perf10Year",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 135,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "5Y (Actual return)",
      headerTooltip: "Total return over 5 years (not annualized)",
      field: "perf5YearTotal",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 140,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "10Y (Actual return)",
      headerTooltip: "Total return over 10 years (not annualized)",
      field: "perf10YearTotal",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 145,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "Total Score",
      headerTooltip: "Overall fundamental score (0–36)",
      field: "totalScore",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 100,
      cellStyle: (params) =>
        params.value != null && params.value > 29 ? { color: "green", fontWeight: 500 } : null,
    },
    {
      headerName: "Company Name",
      field: "companyName",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 150,
    },
    {
      headerName: "Recommendation",
      headerTooltip: "Recommendation",
      field: "recommendation",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 100,
    },
    {
      headerName: "TA Score",
      headerTooltip: "Technical analysis score (0–100); higher = stronger buy signal",
      field: "technicalScore",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 90,
      valueFormatter: (params) =>
        params.value != null ? `${params.value} / 100` : "",
      cellStyle: (params) => {
        if (params.value == null) return null;
        const v = Number(params.value);
        if (v >= 80) return { color: "#0a8a7e", fontWeight: 500 };
        if (v >= 60) return { color: "#0a8a7e" };
        if (v >= 40) return { color: "#b86b00" };
        if (v >= 20) return { color: "#b86b00" };
        return { color: "#b91c1c" };
      },
    },
    {
      headerName: "TA Rec",
      headerTooltip: "Technical recommendation (Strong-TA, Good-TA, Neutral-TA, Weak-TA, Avoid-TA)",
      field: "technicalRecommendation",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 95,
    },
    {
      headerName: "Sector",
      field: "sector",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 120,
    },
    {
      headerName: "Industry",
      headerTooltip: "Industry",
      field: "industry",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 120,
    },

    {
      headerName: "Country",
      headerTooltip: "Country",
      field: "country",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 80,
    },

    {
      headerName: "Size",
      headerTooltip: "Company Size",
      field: "companySize",
      filter: "agTextColumnFilter",
      sortable: true,
      width: 70,
    },
    {
      headerName: "Market Cap",
      field: "marketCap",
      filter: "agNumberColumnFilter",
      valueFormatter: Utils.ag_currencyCompactFormatter,
      sortable: true,
      width: 120,
    },
    {
      headerName: "Dividend",
      headerTooltip: "Dividend",
      field: "lastDiv",
      filter: "agNumberColumnFilter",
      valueFormatter: Utils.ag_currencyFormatter,
      sortable: true,
      width: 120,
    },
    {
      headerName: "Dividend Yield",
      field: "dividendYield",
      filter: "agNumberColumnFilter",
      valueFormatter: Utils.ag_RatioFormatter,
      sortable: true,
      width: 120,
    },
    {
      headerName: "PE Ratio",
      field: "pe",
      filter: "agNumberColumnFilter",
      valueFormatter: Utils.ag_CompactFormatter,
      sortable: true,
      width: 100,
    },
    {
      headerName: "PEG Ratio",
      headerTooltip: "PEG Ratio",
      field: "pegRatio",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 100,
    },
    {
      headerName: "Bookvalue/Share",
      headerTooltip: "Bookvalue/Share",
      field: "bookPerShare",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 110,
      valueFormatter: Utils.ag_currencyFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "Intrinsic Value",
      headerTooltip: "Intrinsic Value",
      field: "intrinsicValue",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 130,
      valueFormatter: Utils.ag_currencyFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "Above/Below  Fair Value",
      headerTooltip: "Discount to Fair Value",
      field: "discIntrinsic",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 180,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },
    {
      headerName: "OverValued/UnderValued",
      headerTooltip: "OverValued/UnderValued",
      field: "reasonablyPriced",
      sortable: true,
      filter: "agTextColumnFilter",
      width: 180,
    },

    {
      headerName: "5 Year Sales Growth",
      headerTooltip: "5 Year Sales Growth",
      field: "salesGrowth",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 150,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "5 Yr Net Income Growth",
      headerTooltip: "5 Yr Net Income Growth",
      field: "netIncomeGrowth",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 180,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "5 Yr Cashflow Growth",
      headerTooltip: "5 Yr Cashflow Growth",
      field: "cashflowGrowth",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 180,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "Past EPS Growth",
      headerTooltip: "Past EPS Growth",
      field: "ePSpast5Y",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 120,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "Future EPS Growth",
      headerTooltip: "Future EPS Growth",
      field: "ePSnext5Y",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 140,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "ROE",
      field: "roe",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 85,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "Gross Margin",
      headerTooltip: "Gross Margin",
      field: "grossMargin",
      sortable: true,
      filter: "agNumberColumnFilter",
      width: 130,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "Profit Margin",
      headerTooltip: "Profit Margin",
      field: "profitMargin",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 130,
      valueFormatter: Utils.ag_RatioFormatter,
      cellStyle: Utils.ag_grid_cell_color_neg_val,
    },

    {
      headerName: "Current Ratio",
      headerTooltip: "Current Ratio",
      field: "currentRatio",
      filter: "agNumberColumnFilter",
      sortable: true,
      width: 130,
    },
  ];

  const isFullScreener = props.portfolio
    ? ["all", "etfall"].includes(props.portfolio.name)
    : false;

  //console.log("Screener isFullScreener:", isFullScreener);

  // const images = require.context("../images/screener-images", true);
  let imageName =
    props.portfolio && props.portfolio.image
      ? props.portfolio.image
      : "portfolio";
  //let imgsrc1 = images(`./${imageName}.jpg`).default;

  let imgsrc = `${process.env.PUBLIC_URL}/images/screener-images/${imageName}.jpg`;

  const imageUrl = props.portfolioImageUrl ? props.portfolioImageUrl : imgsrc;

  return (
    <>
      {isFullScreener ? (
        <div
          style={{
            width: "calc(100% - 1rem)",
            margin: "0.5rem 0.5rem 0.25rem 0.5rem",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card
            fluid
            raised
            style={{
              boxShadow: "none",
              margin: 0,
              borderRadius: "8px",
            }}
          >
            <Card.Content style={{ padding: "0.5rem" }}>
              <Header
                color="blue"
                textAlign="center"
                as="h2"
                style={{ margin: "0.25rem 0" }}
              >
                Screener Results
              </Header>
            </Card.Content>
          </Card>
        </div>
      ) : (
        <div
          style={{
            width: "calc(100% - 1rem)",
            margin: "0.5rem 0.5rem 0.25rem 0.5rem",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card
            fluid
            raised
            style={{
              boxShadow: "none",
              margin: 0,
              borderRadius: "8px",
            }}
          >
            <Card.Content style={{ padding: "0.5rem" }}>
              <Grid stackable padded="0.1em">
                <Grid.Row>
                  <Grid.Column width={2} verticalAlign="top">
                    <Image
                      size="small"
                      style={{
                        mixBlendMode: "multiply",
                        borderRadius: "6px",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        marginTop: "0.1rem",
                      }}
                      src={imageUrl}
                      rounded
                    />
                  </Grid.Column>
                  <Grid.Column width={6} verticalAlign="top">
                    <p
                      className="large text"
                      style={{
                        fontSize: "1rem",
                        lineHeight: "1.4",
                        color: "#4a4a4a",
                        marginBottom: "0.1rem",
                      }}
                    >
                      {props.portfolio?.about ||
                        `Companies in ${
                          props.portfolio?.name || "this screener/sector/ETF"
                        }`}
                    </p>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        color: "primary.dark",
                        fontWeight: 600,
                        mb: 2,
                        mt: 0.5,
                        fontSize: { xs: "1.5rem", md: "1.75rem" },
                        letterSpacing: "-0.02em",
                      }}
                    >
                      Portfolio Performance
                    </Typography>

                    <Header.Subheader>
                      <Card
                        raised
                        fluid
                        style={{ boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
                      >
                        <div style={{ overflowX: "auto" }}>
                          <Table
                            celled
                            compact
                            unstackable
                            style={{ margin: 0 }}
                          >
                            <Table.Header>
                              <Table.Row
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  fontWeight: "600",
                                  color: "#2c3e50",
                                }}
                              >
                                <Table.Cell
                                  singleLine
                                  textAlign="center"
                                  style={{ padding: "0.1rem" }}
                                >
                                  1 Day
                                </Table.Cell>
                                <Table.Cell
                                  singleLine
                                  textAlign="center"
                                  style={{ padding: "0.1rem" }}
                                >
                                  1 Week
                                </Table.Cell>
                                <Table.Cell
                                  singleLine
                                  textAlign="center"
                                  style={{ padding: "0.1rem" }}
                                >
                                  1 Month
                                </Table.Cell>
                                <Table.Cell
                                  singleLine
                                  textAlign="center"
                                  style={{ padding: "0.1rem" }}
                                >
                                  YTD
                                </Table.Cell>
                                <Table.Cell
                                  singleLine
                                  textAlign="center"
                                  style={{ padding: "0.1rem" }}
                                >
                                  1 Year
                                </Table.Cell>
                                <Table.Cell
                                  singleLine
                                  textAlign="center"
                                  style={{ padding: "0.1rem" }}
                                >
                                  5Y (Ann.)
                                </Table.Cell>
                                <Table.Cell
                                  singleLine
                                  textAlign="center"
                                  style={{ padding: "0.1rem" }}
                                >
                                  10Y (Ann.)
                                </Table.Cell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              <Table.Row>
                                <Table.Cell
                                  textAlign="center"
                                  negative={
                                    props.portfolio
                                      ? props.portfolio.perfDay < 0
                                      : false
                                  }
                                  positive={
                                    props.portfolio
                                      ? props.portfolio.perfDay >= 0
                                      : false
                                  }
                                >
                                  {props.portfolio
                                    ? Utils.format_percent(
                                        props.portfolio.perfDay
                                      )
                                    : ""}
                                </Table.Cell>
                                <Table.Cell
                                  textAlign="center"
                                  negative={
                                    props.portfolio
                                      ? props.portfolio.perfWeek < 0
                                      : false
                                  }
                                  positive={
                                    props.portfolio
                                      ? props.portfolio.perfWeek >= 0
                                      : false
                                  }
                                >
                                  {props.portfolio
                                    ? Utils.format_percent(
                                        props.portfolio.perfWeek
                                      )
                                    : ""}
                                </Table.Cell>
                                <Table.Cell
                                  textAlign="center"
                                  negative={
                                    props.portfolio
                                      ? props.portfolio.perfMonth < 0
                                      : false
                                  }
                                  positive={
                                    props.portfolio
                                      ? props.portfolio.perfMonth >= 0
                                      : false
                                  }
                                >
                                  {props.portfolio
                                    ? Utils.format_percent(
                                        props.portfolio.perfMonth
                                      )
                                    : ""}
                                </Table.Cell>
                                <Table.Cell
                                  textAlign="center"
                                  negative={
                                    props.portfolio
                                      ? props.portfolio.perfYTD < 0
                                      : false
                                  }
                                  positive={
                                    props.portfolio
                                      ? props.portfolio.perfYTD >= 0
                                      : false
                                  }
                                >
                                  {props.portfolio
                                    ? Utils.format_percent(
                                        props.portfolio.perfYTD
                                      )
                                    : ""}
                                </Table.Cell>
                                <Table.Cell
                                  textAlign="center"
                                  negative={
                                    props.portfolio
                                      ? props.portfolio.perfYear < 0
                                      : false
                                  }
                                  positive={
                                    props.portfolio
                                      ? props.portfolio.perfYear >= 0
                                      : false
                                  }
                                >
                                  {props.portfolio
                                    ? Utils.format_percent(
                                        props.portfolio.perfYear
                                      )
                                    : ""}
                                </Table.Cell>

                                <Table.Cell
                                  textAlign="center"
                                  negative={
                                    props.portfolio
                                      ? props.portfolio.perf5Year < 0
                                      : false
                                  }
                                  positive={
                                    props.portfolio
                                      ? props.portfolio.perf5Year >= 0
                                      : false
                                  }
                                >
                                  {props.portfolio
                                    ? Utils.format_percent(
                                        props.portfolio.perf5Year
                                      )
                                    : ""}
                                </Table.Cell>
                                <Table.Cell
                                  textAlign="center"
                                  negative={
                                    props.portfolio
                                      ? props.portfolio.perf10Year < 0
                                      : false
                                  }
                                  positive={
                                    props.portfolio
                                      ? props.portfolio.perf10Year >= 0
                                      : false
                                  }
                                >
                                  {props.portfolio
                                    ? Utils.format_percent(
                                        props.portfolio.perf10Year
                                      )
                                    : ""}
                                </Table.Cell>
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        </div>
                      </Card>
                    </Header.Subheader>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Content>
          </Card>
        </div>
      )}

      <div
        style={{
          height: isFullScreener
            ? "calc(100vh - 8rem - 4rem)" // Full screener: account for header, margins, and bottom nav
            : "calc(100vh - 19rem - 4rem)", // Regular screener: account for header, card, margins, and bottom nav
          overflowX: "auto",
          margin: "0.5rem 0.5rem 4.5rem 0.5rem", // Added bottom margin for mobile nav
          padding: 0,
          width: "calc(100% - 1rem)",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
        className="ag-theme-quartz"
      >
        <style>
          {`
            .ag-theme-quartz .ag-header {
              background-color: #f0f2f5 !important;
              border-bottom: 2px solid #e0e3e7 !important;
            }
            .ag-theme-quartz .ag-header-cell {
              background-color: #f0f2f5 !important;
              border-right: 1px solid #e0e3e7 !important;
            }
            .ag-theme-quartz .ag-header-cell-text {
              color: #1a1a1a !important;
              font-weight: 600 !important;
              font-size: 0.9rem !important;
            }
            .ag-theme-quartz .ag-header-cell:hover {
              background-color: #e4e6e9 !important;
            }
            .ag-theme-quartz .ag-floating-filter-button {
              color: #1a1a1a !important;
            }
            .ag-theme-quartz .ag-floating-filter-button:hover {
              background-color: #e4e6e9 !important;
            }
            .ag-theme-quartz .ag-header-cell-resize {
              background-color: #e0e3e7 !important;
            }
            .ag-theme-quartz .ag-header-cell-menu-button {
              color: #1a1a1a !important;
            }
            .ag-theme-quartz .ag-header-cell-menu-button:hover {
              background-color: #e4e6e9 !important;
            }
          `}
        </style>
        <AgGridReact
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          rowData={props.portfolio?.stockReports || []}
          pagination={true}
          overlayLoadingTemplate={overlayLoadingTemplate}
          onCellClicked={showModal}
        />
      </div>

      <Modal
        closeOnEscape={true}
        onClose={() => setOpen(false)}
        centered
        open={stateValues.open}
        size="fullscreen"
        style={{
          marginLeft: "1%",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <Modal.Content scrolling style={{ padding: "0.25rem" }}>
          <CompanyPage symbol={stateValues.modalSymbol} />
        </Modal.Content>
        <Modal.Actions style={{ padding: "0.25rem" }}>
          <Button
            className="ui blue button"
            onClick={() => setOpen(false)}
            style={{
              borderRadius: "4px",
              padding: "0.4rem 1rem",
              fontWeight: "500",
            }}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}
